<template>

    <div id="app" style="flex: 1">
        <div id="head_container">
            <div id="title_container">
                <div id="logo">
                    <img alt="Vue logo" src="./assets/pang_icon.png" style="width:155px; height:160px; margin: 10px;">
                </div>
                <div id="ad_tab">
                    <img src="./assets/home_ad01.png" style="width:256px; height:170px; margin: 10px;">
                </div>
                <div id="login_tab">
                    <div id="user_info" v-if="bLogin">
                        <div class="nick" style=" display:block">
                            <label id="user_info_text" v-text="Nick"
                                style="font-weight: bold; color: #2d88ff; font-family: 'HYGothic'; font-size: 18px; text-align: center; display: inline-flex;"></label>
                            <label id="user_info_text"
                                style="font-weight: bold; color: #ffffff; font-family: 'HYGothic'; font-size: 18px; text-align: center; display: inline-flex;">&nbsp;님</label>
                        </div>
                        <div class="money">
                            <label v-text="'보유머니 :&nbsp;'"
                                style="font-family: 'HYGothic'; font-size: 15px; font-weight: bold; color: #ffffff;" />
                            <label style="font-family: 'HYGothic'; font-size: 15px; font-weight: bold; color: #2d88ff;">
                                {{ cashLabel }}
                            </label>
                            <label v-text="'&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;포인트 :&nbsp;'"
                                style="font-family: 'HYGothic'; font-size: 15px; font-weight: bold; color: #ffffff;" />
                            <label style="font-family: 'HYGothic'; font-size: 15px; font-weight: bold; color: #2d88ff;">
                                {{ pointLabel }}
                            </label>
                            <div type="button" id="refresh_money" @click="exchange_point()" />
                        </div>
                    </div>
                    <div id="login_btns" v-if="!bLogin">
                        <button id="round_button" @click="OpenPopup('login')"
                            style="position: absolute; right: 150px; top: 120px;">로그인</button>
                        <button id="round_button" @click="OpenPopup('join')"
                            style="position: absolute; right: 50px; top: 120px;">회원가입</button>
                    </div>
                    <div id="logined_btns" v-if="bLogin">
                        <button id="round_button" @click="OpenPopup('userinfo')"
                            style="position: absolute; right: 150px; top: 120px;">마이페이지</button>
                        <button id="round_button" @click="LogOut()"
                            style="position: absolute; right: 50px; top: 120px;">로그아웃</button>
                    </div>
                </div>
            </div>
        </div>
        <Header />
        <HomeView v-if="bLogin" />
    </div>
    <NoticePopups :notices="notices" @remove="removePopup" ref="noticePopup" v-if="!bLogin"/>
    <RealTimeNotice :rt_notices="rt_notices" @remove="removeRTPopup" ref="RT_notice" v-if="bLogin"/>
    <Transition name="fade">
        <div v-if="pModalViewed" class="modal-open">
            <ModalView>
                <template v-slot:header>

                    <PopupTab v-if="!pJoin && !pLogin" />
                    <div id="popup_title" v-if="pJoin">회원가입</div>
                    <div id="deposit_container" v-if="pDeposit">
                        <div id="popup_title_container">
                            <div id="popup_title">충전신청</div>
                        </div>
                    </div>
                    <div id="withdraw_container" v-if="pWithdraw">
                        <div id="popup_title_container">
                            <div id="popup_title">환전신청</div>
                        </div>
                    </div>
                    <div id="money_container" v-if="pMoneyPopup">
                        <div id="popup_title_container">
                            <div id="popup_title">머니내역</div>
                        </div>
                    </div>
                    <div id="notice_container" v-if="pNotice">
                        <div id="popup_title_container">
                            <div id="popup_title">공지사항</div>
                        </div>
                    </div>
                    <div id="userinfo_container" v-if="pUserInfo">
                        <div id="popup_title_container">
                            <div id="popup_title">마이 페이지</div>
                        </div>
                    </div>
                    <div id="qna_container" v-if="pMsgPopup">
                        <div id="popup_title_container">
                            <div id="popup_title">1:1 문의</div>
                        </div>
                    </div>
                </template>
                <template v-slot:body>
                    <MsgPopup v-if="pMsgPopup" />
                    <Login v-if="pLogin" />
                    <Join v-if="pJoin" />
                    <Deposit v-if="pDeposit" />
                    <Withdraw v-if="pWithdraw" />
                    <Notice v-if="pNotice" />
                    <UserInfo v-if="pUserInfo" />
                    <MoneyList v-if="pMoneyPopup" />
                </template>
            </ModalView>
        </div>

    </Transition>

</template>

<script>
import { onBeforeUnmount } from 'vue';
import Header from './components/layout/Header.vue'

import ModalView from "./components/layout/ModalView.vue";
import PopupTab from './components/layout/popup/PopupTab.vue'
import Login from "./components/layout/popup/Login.vue";
import Join from "./components/layout/popup/Join.vue";
import Deposit from "./components/layout/popup/Deposit.vue";
import Withdraw from "./components/layout/popup/Withdraw.vue";
import Notice from "./components/layout/popup/Notice.vue";
import UserInfo from "./components/layout/popup/UserInfo.vue";
import MsgPopup from "./components/layout/popup/MsgPopup.vue"
import MoneyList from "./components/layout/popup/MoneyList.vue"

import store from './components/js/store.js'
import Swal from "sweetalert2";
import API from './components/js/API';
import { EventBus } from './components/js/eventBus';  // EventBus를 임포트
import { ref, computed, onMounted, getCurrentInstance  } from 'vue';

import NoticePopups from './components/layout/popup/NoticePopups.vue';
import RealTimeNotice from './components/layout/popup/RealTimeNotice.vue';

import HomeView from './views/HomeView.vue';


export default {
    name: 'App',
    components: {
        Header,
        ModalView,
        Login,
        Join,
        PopupTab,
        Deposit,
        Withdraw,
        Notice,
        UserInfo,
        MsgPopup,
        MoneyList,
        NoticePopups,
        RealTimeNotice,
        HomeView
    },
    setup() {
        const notices = ref([]);
        const counter = ref(1);
        const form = { };
        const list = [];
        const { proxy } = getCurrentInstance();

        const GetNotice = () => {
            API.AxiosPost('info/getInfo', form, false,
                (res) => {
                    const noticeReadList = store.state.notice_read_list; // 저장된 읽은 공지사항 리스트 가져오기
                    const currentNoticeIdxs = new Set(); // 현재 공지사항 idx 값을 저장할 Set
                    console.log(noticeReadList);
                    res.data.data.forEach(element => {
                        if (element.type == 0) {
                            addPopup(element.idx, element.title, element.content);
                        }
                        else {
  
                            list.push(element);
                            currentNoticeIdxs.add(element.idx); // 현재 공지사항 idx 값 추가
                        }
                    });
                    console.log(list);
                    // noticeReadList에 있지만 currentNoticeIdxs에 없는 idx 값을 필터링
                    const updatedNoticeReadList = noticeReadList.filter(idx => currentNoticeIdxs.has(idx));

                    // 변경된 notice_read_list를 로컬 스토리지에 저장
                    if (updatedNoticeReadList.length !== noticeReadList.length) {
                        store.commit('setNoticeReadList', updatedNoticeReadList);
                        //localStorage.setItem(`${accountId}_read_notice`, JSON.stringify(updatedNoticeReadList));
                    }

                    store.commit('setNoticeList', list.reverse()); // 역순으로 저장하고 싶다면 유지


                    if (store.state.notReadExist && proxy.bLogin)
                        proxy.OpenPopup('notice');
                }
            );
        };

        const addPopup = (_id, _title, _msg) => {
            if (!shouldHidePopup(_id)) {

                notices.value.push({  title: _title, id: _id, message: _msg });
                counter.value++;
            }
        };

        const removePopup = (id) => {
            notices.value = notices.value.filter(notice => notice.id !== id);
        };

        const shouldHidePopup = (id) => {
            const storedData = localStorage.getItem(id);
            if (storedData) {
                const now = new Date();
                const hideDate = new Date(JSON.parse(storedData).date);

                // 현재 날짜와 숨김 날짜가 같은 날인지 확인
                if (
                    now.getFullYear() === hideDate.getFullYear() &&
                    now.getMonth() === hideDate.getMonth() &&
                    now.getDate() === hideDate.getDate()
                ) {
                    return true;
                } else {
                    // 다른 날짜일 경우 로컬 스토리지에서 데이터 삭제
                    localStorage.removeItem(id);
                    return false;
                }
            }
            return false;
        };
        
        onMounted(() => {
            //localStorage.clear();
            GetNotice();
        });
        
        // 페이지가 닫히기 전에 팝업 표시 함수
        const confirmClose = () => {
            if (store.state.game_pop_state.game)
            {
                const pop = window.open("", 'game');
                pop.close();
            }
        };

        // beforeUnmount 훅에서 이벤트 리스너 등록
        onBeforeUnmount(() => {
            window.removeEventListener('beforeunload', confirmClose);
        });

        // beforeunload 이벤트 리스너 등록
        window.addEventListener('beforeunload', confirmClose);
        

        // computed 속성을 사용하여 inputValue가 변경될 때마다 label 값을 계산
        const cashLabel = computed(() => {
            return `${(store.state.user.cash).toLocaleString('ko-KR')}`;
        });
        const pointLabel = computed(() => {
            return `${(store.state.user.point).toLocaleString('ko-KR')}`;
        });

        return {
            cashLabel,
            pointLabel,
            notices,
            addPopup,
            removePopup
        };
    },
    mounted() {
        this.connect();
        this.CheckLogined();
        EventBus.on('logOut', this.LogOut);  // 로그아웃 이벤트를 수신하여 LogOut 메소드 호출;
        store.os = this.detectOS();
        if (this.bLogin) {
            API.checkToken();
        }
            
    },
    beforeUnmount() {
        EventBus.off('logOut', this.LogOut);  // 컴포넌트가 제거되기 전에 이벤트 리스너 제거
    },
    data() {
        return {
            socket_data : {
                messageId : '',
                userId : '',
                data : '',
                grade : '',
                os : this.detectOS()
            },
            login_form : {
                user_id: '',
                password: '',
            },
            Msg:"",
            
            // 팝업 관리 bool
            pModalViewed: false,
            pLogin: false,     
            pJoin: false,
            pWithdraw: false,
            pUserInfo: false,
            pDeposit: false,
            pNotice: false,
            pMsgPopup: false,
            pMoneyPopup: false,

            bLogin: false,      //로그인 상태값
            Nick: "",
            Money: 0,
            Point: 0,
            logs: [],
            message: "",
            html: `<span style="color: blue">Nick</span>`,

            rt_notices : []
            };
    },
    created() {
        //EventBus.$on('logOut', this.LogOut);  // 로그아웃 이벤트를 수신하여 LogOut 메소드 호출
    },
    methods:{
        
        OpenPopup: function(_type){

            API.checkToken(()=>{
                switch (_type) {
                    case "join":
                        this.pModalViewed = true;
                        this.pJoin = true;
                        break;
                    case "login":
                        this.pModalViewed = true;
                        this.pLogin = true;
                        break;
                    case "deposit":
                        if (this.bLogin) {
                            this.pModalViewed = true;
                            this.pDeposit = true;
                        }
                        else
                            Swal.fire({
                                icon: 'info',
                                title: '로그인 후 이용 가능합니다.',
                                text: '로그인 하시겠습니까?',
                                showCancelButton: true,
                                confirmButtonText: '확인',
                                cancelButtonText: '취소'
                            }).then((result) => {
                                if (result.isConfirmed) {
                                    this.pModalViewed = true;
                                    this.pLogin = true;
                                }
                            })
                        break;
                    case "withdraw":
                        if (this.bLogin) {
                            this.pModalViewed = true;
                            this.pWithdraw = true;
                        }

                        else
                            Swal.fire({
                                icon: 'info',
                                title: '로그인 후 이용 가능합니다.',
                                text: '로그인 하시겠습니까?',
                                showCancelButton: true,
                            }).then((result) => {
                                if (result.isConfirmed) {
                                    this.pModalViewed = true;
                                    this.pLogin = true;
                                }
                            })
                        break;
                    case "notice":
                        if (this.bLogin) {
                            this.pModalViewed = true;
                            this.pNotice = true;
                        }
                        else
                            Swal.fire({
                                icon: 'info',
                                title: '로그인 후 이용 가능합니다.',
                                text: '로그인 하시겠습니까?',
                                showCancelButton: true,
                            }).then((result) => {
                                if (result.isConfirmed) {
                                    this.pModalViewed = true;
                                    this.pLogin = true;
                                }
                            })
                        break;
                    case "userinfo":
                        this.pModalViewed = true;
                        this.pUserInfo = true;
                        break;
                    case "qna":
                        if (this.bLogin) {
                            this.pModalViewed = true;
                            this.pMsgPopup = true;
                        }
                        else
                            Swal.fire({
                                icon: 'info',
                                title: '로그인 후 이용 가능합니다.',
                                text: '로그인 하시겠습니까?',
                                showCancelButton: true,
                            }).then((result) => {
                                if (result.isConfirmed) {
                                    this.pModalViewed = true;
                                    this.pLogin = true;
                                }
                            })
                        break;
                    case "money":
                        if (this.bLogin) {
                            this.pModalViewed = true;
                            this.pMoneyPopup = true;
                        }
                        else
                            Swal.fire({
                                icon: 'info',
                                title: '로그인 후 이용 가능합니다.',
                                text: '로그인 하시겠습니까?',
                                showCancelButton: true,
                            }).then((result) => {
                                if (result.isConfirmed) {
                                    this.pModalViewed = true;
                                    this.pLogin = true;
                                }
                            })
                        break;
                    default:
                        Swal.fire({
                            icon: 'info',
                            title: '준비중',
                            text: '아직 준비중인 기능입니다.'
                        })
                        break;
                }
                }
            );
        },
        ChangePopup: function(_type){
            if (store.state.notReadExist && this.pNotice) {
                Swal.fire({
                    text: '읽지 않은 공지가 있습니다.'
                })
            }
            else {
                this.pModalViewed = false;
                this.pDeposit = false;
                this.pWithdraw = false;
                this.pUserInfo = false;
                this.pNotice = false;
                this.pMsgPopup = false;
                this.pMoneyPopup = false;

                switch (_type) {
                    case "deposit":
                        this.pDeposit = true;
                        break;
                    case "withdraw":
                        this.pWithdraw = true;
                        break;
                    case "userinfo":
                        this.pUserInfo = true;
                        break;
                    case "notice":
                        this.pNotice = true;
                        break;
                    case "qna":
                        this.pMsgPopup = true;
                        break;
                    case "money":
                        this.pMoneyPopup = true;
                        break;
                }
                this.pModalViewed = true;
            }
            
        },
        ClosePopup: function(){
            if (store.state.notReadExist && this.pNotice) {
                Swal.fire({
                    text: '읽지 않은 공지가 있습니다.'
                })
            }
            else
            {
                this.pModalViewed = false;
                this.pJoin = false;
                this.pLogin = false;
                this.pDeposit = false;
                this.pWithdraw = false;
                this.pNotice = false;
                this.pUserInfo = false;
                this.pMsgPopup = false;
                this.pMoneyPopup = false;
                this.CheckLogined();
            }
            
        },
        LogOut: function(){
            if (this.trueKeys().length > 0) {
                Swal.fire({
                    icon: 'warning',
                    title: '로그아웃 확인',
                    html: '실행중인 게임이 종료됩니다.<br>로그아웃 하시겠습니까?',
                    showCancelButton: true,
                    confirmButtonText: '확인',
                    cancelButtonText: '취소'
                }).then((result) => {
                    if (result.isConfirmed) {
                        console.log(this.trueKeys());
                        for (var key of this.trueKeys()) {
                            const popup = window.open("", key);
                            popup.close();
                        }
                        this.sendMessage('out room');
                        store.commit('removeUser', store.state);
                        this.CheckLogined();
                        API.showToast('success', '로그아웃 완료');
                    }
                })
            }
            else {
                this.sendMessage('out room');
                store.commit('removeUser', store.state);
                API.showToast('success', '로그아웃 완료');
                this.CheckLogined();
            }
        },
        CheckLogined: function(){
            if (store.state.user.token == null || store.state.user.token == '')
            {
                this.bLogin = false;
                // router.push('');
            }
            else
            {
                this.checkReadNotice();
                if (store.state.notReadExist)
                    this.OpenPopup('notice');
                this.bLogin = true;
                this.Nick = store.state.user.nickname;
                this.Money = store.state.user.cash;
                this.Point = store.state.user.point;
            }
                
        },
        connect() {
            this.socket = new WebSocket(encodeURI(API.SOCKET_URL()));
            this.socket.onopen = () => {
                this.status = "connected";
                console.log("소켓 연결 완료");   // URL(IP) 미출력
                if (this.bLogin) {
                    this.sendMessage('join room');
                }

                this.socket.onmessage = ( event ) => {
                    console.log("메세지 수신 : " + event.data);
                    const json_data = JSON.parse(event.data);
                    switch(json_data.event)
                    {
                        case 'join room':
                            store.commit('setSecret', json_data["secret"]);
                            store.commit('setServicePreset', json_data["preset"])
                            break;
                        case 'leave room':
                            this.LogOut();
                            this.pModalViewed = false;
                            this.pJoin = false;
                            this.pLogin = false;
                            this.pDeposit = false;
                            this.pWithdraw = false;
                            this.pNotice = false;
                            this.pUserInfo = false;
                            this.pMsgPopup = false;
                            this.pMoneyPopup = false;
                            if (store.state.game_pop_state.game) {
                                const pop = window.open("", 'game');
                                pop.close();
                            }
                            Swal.fire({
                                icon: 'warning',
                                title: '중복 로그인 감지',
                                html: '다른 곳에서 접속이 감지되어 로그아웃되었습니다.<br>잘못된 접속이면 운영진에 문의하시기 바랍니다.',
                            })
                            break;
                        case 'sys msg':
                            switch(json_data.code)
                            {
                                case 'live_info':
                                    this.rt_notices = [];
                                    this.rt_notices.push({  title: json_data.title, message: json_data.content });
                                    break;
                                case 'live_game_setting': {
                                    // 서버가 보낸 gameN 키를 전부 그대로 반영.
                                    // (game1,game2,... 하드코딩 나열 제거 → 게임 추가 시 홈페이지 재빌드 불필요.
                                    //  gameN 을 실제로 보내는 건 백엔드 몫)
                                    const settings = {};
                                    Object.keys(json_data).forEach(k => {
                                        if (/^game\d+$/.test(k)) settings[k] = json_data[k];
                                    });
                                    store.commit('setGameSettings', settings);
                                    break;
                                }
                            }
                            break;
                    }
                };
            };
        },
        disconnect() {
            this.socket.close();
            this.status = "disconnected";
            this.logs = [];
        },
        sendMessage(e) {
            this.socket_data.messageId = e;
            this.socket_data.userId = store.state.user.id;

            this.message = e;
            if (store.state.user.grade == "tester" || store.state.user.grade == "member")
                this.socket_data.grade = 1;
            else
                this.socket_data.grade = 2;
            this.socket.send(JSON.stringify(this.socket_data));
            //this.logs.push({ event: "메시지 전송", data: this.socket_data });
            console.log("메시지 전송 : " + e);
            this.message = "";
        },
        toNumberFormatOfKor(num) {
            return `${num.toLocaleString('ko-KR')}`;
        },
        detectOS() {
            const userAgent = window.navigator.userAgent.toLowerCase();
            if (userAgent.includes('windows')) {
                return 'win';
            } else if (userAgent.includes('android')) {
                return 'aos';
            } else if (userAgent.includes('iphone') || userAgent.includes('ipad') || userAgent.includes('ipod') || userAgent.includes('ios')) {
                return 'ios';
            } else {
                return 'unknown'; // If OS is not detected
            }
        },
        trueKeys() {
            const trueKeys = [];
            for (const key in store.state.game_pop_state) {
                if (store.state.game_pop_state[key]) {
                    trueKeys.push(key);
                }
            }
            return trueKeys;
        },
        refresh_money() {
            const form = { }
            API.AxiosPost('users/userInfoMin', form, true,
                (res) => {
                    if (res.data.code == '200') {
                        const money_data = {
                            cash: res.data.data.cash || 0,
                            credit: res.data.data.credit || 0,
                            point: res.data.data.point || 0,
                        }
                        store.commit('updateMoney', money_data);
                        this.Money = money_data.cash;
                        this.Point = money_data.point;
                    } else {
                        Swal.fire({
                            title: '요청 실패',
                            icon: 'error',
                            html: '정상적으로 진행되지 않았습니다.<br>잠시 후 다시 시도해 주세요.',
                        });   
                        console.log("refresh_money failed - code:", res.data.code);
                    }
                }
            )
        },
        exchange_point() {
            this.refresh_money();
            if (store.state.user.point > 0) {
                Swal.fire({
                    icon: 'info',
                    title: '포인트 전환',
                    html: '포인트를 보유금으로 전환합니다.<br>전환 하시겠습니까?',
                    showCancelButton: true
                }).then(
                    (result) => {
                        if (result.isConfirmed) {
                            const form = {}
                            API.AxiosPost('users/changePoint', form, true,
                                (res) => {
                                    if (res.data.code == '200') {
                                        const money_data = {
                                            cash: res.data.cash,
                                            credit: store.state.user.credit,
                                            point: 0,
                                        }
                                        store.commit('updateMoney', money_data);
                                        API.showToast('success', '포인트 전환 완료');
                                    }
                                }
                            )
                        }
                    })
            }
            else{
                Swal.fire({
                    icon: 'warning',
                    title: '포인트 부족',
                    html: '전환할 포인트가 없습니다.',
                })
            }
            
        },
        closeAllPopups() {
            this.$refs.noticePopup.closeAllPopups();
        },
        checkReadNotice() {
            if (store.state.notice_list.length > 0) {
                const readNotice = JSON.parse(localStorage.getItem(store.state.user.id + '_read_notice'));
                if (readNotice) {
                    store.state.notice_list.forEach(element => {
                        const isRead = readNotice.includes(element.idx); // idx 값이 notice_read_list에 있는지 확인
                        if (!isRead) {
                            console.log(':: Not Read Notice Exist ::');
                            store.state.notReadExist = true;
                        }
                        store.commit('setNoticeRead', { idx: element.idx, isRead: isRead });
                    });
                }
                else {
                    store.state.notReadExist = true;
                }
            }
        },
        removeRTPopup () {
            this.rt_notices = [];
        }
    }
}
</script>

<style>
@font-face {
    font-family: 'HYGothic'; /*font 이름*/
    src: url('assets/NanumBarunGothic.ttf')
}

#app {
    overflow-x: hidden;
    min-width: 900px;
    width: 100%;
    height: 100%;
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    background-color: #080403;
}
#head_container{
    width: 900px;
    height: 180px;
    margin: 0px auto;
    padding: 5px 0px 10px 0px;
}

#title_container{
    width: 1000px;
    position: relative;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
}

#logo {
    position: absolute;
    left:50%;
    transform:translateX(-50%);
}
.logo{
    filter:grayscale(1);
    opacity: 0.3;
    float: left;
}

#login_tab{
    min-width: 1030px;
    width: 50vw;
    height: 160px;
    margin: 0 auto;
    display: flex;
    justify-content: right;
    align-items: center;
}
#ad_tab{
    position: absolute;
    left:15%;
    transform:translateX(-50%);
}
.foot_container {
    overflow-x: hidden;
    padding-top: 25px;
    height: 150px;
    
    width: 900px;
    margin: 0 auto;
}
.foot_container div:nth-child(n){
    width: 100%;
    margin: 0 auto;
    text-align: left;
}
.copy div:nth-child(n) {
    font-size: 13px;
    color:#838383;
}
.info div:nth-child(n) {
    font-size: 13px;
    color:#838383;
}
.fade-enter-active {
    transition: opacity 0.2s ease;
    animation: bounce-in 0.25s;
}

.fade-leave-active {
  transition: opacity 0.2s ease;
  animation: bounce-in 0.25s reverse;
}
@keyframes bounce-in {
  0% {
    transform: scale(1.25);
  }
  100% {
    transform: scale(1);
  }
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
#round_button{
    height: 35px;
    width: 80px;
    border: 1px;
    border-radius: 5px 5px 5px 5px / 5px 5px 5px 5px;
    margin-bottom: 10px;
    background-color: #2d88ff;
    color: white;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
    font-size: 13px;
}
#popup_title_container{
    width: 100%;
    height: 50px;
    position: relative;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
}
#popup_title{
    height: 100%;
    width: 720px;
    border-radius: 10px 10px 10px 10px / 10px 10px 10px 10px;
    font-family: Helvetica, Arial, sans-serif;
    color: white;
    font-size: 18px;
    font-weight: bold;
    display: flex;
    margin: 0 auto;
    justify-content: center;
    align-items: center;
    text-align: center;
    padding-top: 6px;
    background-color: rgba(0, 0, 0, 0.85);
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
    letter-spacing: 5px;
    border:2px solid #2d88ff ;
}
#user_info{
    margin-bottom: 20px;
    width: 340px;
    height: 65px;
    border:2px solid #2d88ff ;
    border-radius: 10px 10px 10px 10px / 10px 10px 10px 10px;
    text-align: center;
    padding-top: 7px;
}

.swal2-icon {
      font-size: 10px; /* 원하는 크기로 조절 */
}
.custom-toast {
    
    max-width: 400px;
    font-weight: bold;
    font-family: 'HYGothic';
    top: 40px;
    overflow: hidden !important;  /* ← 추가: 스크롤바 강제 숨김 */
}
.modal-open {
  overflow: hidden; /* 스크롤 방지 */
}
.money {
    display: flex;
    align-items: center;
    justify-content: center; /* 가로 중앙 정렬 */
    /* 수직 중앙 정렬 */
}

.money label {
    font-family: 'HYGothic';
    font-size: 15px;
    font-weight: bold;
    text-align: center;
    margin-top: 2px;
    display: inline-flex;
}

.white-text {
    color: #ffffff;
}

.blue-text {
    color: #2d88ff;
}

#refresh_money {
    width: 24px;
    /* 버튼의 너비 */
    height: 24px;
    /* 버튼의 높이 */
    background-image: url('./assets/change_normal.png');;
    /* 버튼 이미지 경로 */
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    border: none;
    cursor: pointer;
    margin-left: 10px;
    /* 버튼과 텍스트 사이의 간격 */
}

html, body {
  margin: 0;
  padding: 0;
  height: 100%;
  background-color: black;
}

</style>
